import type { Sport } from '__generated__/globalTypes';
import type { Color } from 'style/types';

import {
  findThresholdColor,
  maxScoresBySport,
  thresholdsBySport,
} from './thresholds';

export const normalizeStatsFromRawScores = (
  rawScores: (number | null)[],
  sport: Sport,
  size: number
) => {
  const sportThresholds = thresholdsBySport[sport];
  return [
    ...new Array(size - rawScores.length).fill(null),
    ...[...rawScores].reverse(),
  ].map(so5Score => {
    let color: Color;
    let percent: number;
    if (so5Score === null) {
      percent = 1 / sportThresholds.length;
      color = 'var(--c-nd-600)';
    } else if (so5Score < 0) {
      percent = 1 / sportThresholds.length;
      color = 'var(--c-red-400)';
    } else {
      percent = Math.min(1, so5Score / maxScoresBySport[sport]);
      color = findThresholdColor(so5Score, sport).color;
    }

    return { percent, color };
  });
};
